<template>
  <div class="view_page">
    <div class="page_head"></div>
    <div class="page_body">
      <div class="content">
        <div class="content-select" style="width:100%;height:8%;display:flex;justify-content: center;">
          <i class="ic_check" @click="LmkUserInfo"></i>
          <input type="text" class="checked" placeholder="名称搜索" v-model="nickname" @blur="LmkUserInfo"/>
        </div>
        <div  class="content-body" v-if="statusCard.length>0">
          <div
            class="content-user"
            v-for="(item,index) in statusCard"
            :key="index"
            @click="Order(item,index)"
          >
            <img
              :src="item.avatar"
              alt
              class="kximg"
            />
            <div class="hxtext">
              <div style="margin-bottom: 10px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                 <span
                   v-if="item.nickname!=null"
                   style="font-family:PingFangSC-Regular;font-weight:400;color:rgba(0,0,0,1);font-size:15.5px;"
                 >
                   {{item.nickname}}</span>
              </div>
              <div>
                <span style="color:rgba(143,143,143,1)" v-if="item.phone!=null">{{item.phone}}</span>
                <span style="float:right;color:rgba(143,143,143,1)">{{item.addTime}}</span>
              </div>
            </div>
          </div>
          <div @click="getMore" v-if="isMore"  style="text-align: center;">更多</div>
          <div @click="getMore" v-else style="text-align: center;">暂无更多</div>
        </div>
        <div class='null' v-else>
          <img class='pic'  src="../../../resource/img/pic_coupon_empty.png" />
          <div>暂无内容</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  let page = 1;
  let limit = 20;
  export default {
    name: "MerUnionmbViewAlliance",
    data() {
      return {
        phone:"",
        nickname:"",
        merId:null,
        storeId:null,
        activityId:null,
        statusCard: [],
        total:0,
        isMore:true,
        activityType:0
      };
    },
    created() {
      this.merId = this.$route.query.merId;
      this.activityId = this.$route.query.activityId;
      this.storeId = this.$route.query.storeId;
      this.activityType = this.$route.query.activityType;
      this.LmkUserInfo();
    },
    methods: {
      LmkUserInfo: function() {
        let that = this;
        let data = {
          merId:that.merId,
          page: page,
          limit: limit,
          nickname: that.nickname,
          isMore:false
        };

        that.$axios
          .post(
            "/merchant/api/user/fans/find/list",
            that.$qs.stringify(data)
          )
          .then(response => {
            let listr = this.statusCard;
            let list = response.data.data;
            let total = response.data.count;
            if(page>1){
                for (let i in list) {
                  listr.push(list[i])
                }
            }else{
              listr = list;
            }
            if(total > page*limit){
              this.isMore = true
            }else{
              this.isMore = false
            }
            that.statusCard =listr;
            that.total = response.data.count;
          })
          .catch(function(error) {
            //请求失败处理
            console.log(error);
          });
      },
      Order: function(item,index) {
        if(item.uid!=null && item.uid!=''){
          let that = this;
          if(that.activityType == 0){
            that.$router.push({
              path: "/MerTokerMerUserDetail",
              query: {
                storeId: that.storeId,
                activityId: that.activityId,
                merId:item.merId,
                uid: item.uid,
                user:JSON.stringify(item)
              }
            });
          }else{
            that.$router.push({
              path: "/MerUnionMerUserDetail",
              query: {
                storeId: that.storeId,
                activityId: that.activityId,
                merId:item.merId,
                uid: item.uid,
                user:JSON.stringify(item)
              }
            });

          }

        }
      },
      getMore:function () {
        let totalCounts = this.total;
        if (page * limit >= totalCounts) {
            this.isMore= false
        } else {
          this.isMore= true;
          page = page+1;
          this.LmkUserInfo();
        }
      }
    }
  };
</script>
<style scoped>
  .view_page {
    width: 100%;
    height: 100%;
    margin-top: 50px;
  }
  .page_head {
    width: 100%;
    height: 15vh;
    background-color: #5D4DA8;
    /*background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");*/
  }
  .page_body {
    width: 100%;
    /*height: 64vh;*/
    background: rgba(255, 255, 255, 1);

    display: flex;
    justify-content: center;
  }
  .content {
    width: 94%;
    height: 80vh;
    border-radius: 20px 20px 20px 20px;
    position: relative;
    top: -11vh;
  }

  .content-select{
    width:100%;
    height:8%;
    display:flex;
    justify-content: center;
  }

  .content-body{
    width:100%;
  /*  height:90vh;*/
    display:flex;
    flex-direction: column;
  }
  .content-user{
    width:100%;
    height:150px;
    border-radius:2vw;
    margin-bottom: 5%;
    background-color: rgba(242, 242, 242, 1);
  }

  .checked {
    width: 61%;
    height: 4vh;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    border: none;
    padding-left: 7vh;
    outline: none;
  }
  .ic_check {
    position: relative;
    left: 6vh;
    z-index: 5;
    background-image: url("../../../resource/img/sousuo.png"); /*引入图片图片*/
    background-repeat: no-repeat; /*设置图片不重复*/
    background-size: 40px;
    width: 50px; /*设置图片显示的宽*/
    height: 50px; /*图片显示的高*/
    margin-top: 1vh;
  }
  .kximg {
    width: 16%;
    height: 65%;
    padding-left: 4%;
    padding-top: 4%;
    float: left;
  }
  .hxtext {
    width: 70%;
    height: 100%;
    padding-left: 2%;
    padding-top: 3%;
    float: left;
  }

  .null {
    margin-top: 17vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .null .pic {
    width: 200px;
    height: 200px;
  }
</style>




// WEBPACK FOOTER //
// src/components/active/member/MerTokerMerUserinfo.vue